import {
	useSalesChannelCategoryGroupProductCreateMutation,
	useSalesChannelCategoryGroupProductDeleteMutation,
	useSalesChannelCategoryGroupProductReorderMutation,
	useSalesChannelCategoryGroupProductUpdateMutation,
} from "@/generated/graphql";

export interface GroupProductCreateInput {
	salesChannelCategoryGroupID: string;
	salesChannelCategoryID: string;
	productID: string;
	productCode?: string;
	productName?: string;
	barcode?: string;
	isActive: boolean;
	priceType?: string;
	customPrice?: number;
	externalImageURL?: string;
	imageType?: string;
}

export interface GroupProductUpdateInput extends GroupProductCreateInput {
	salesChannelCategoryGroupProductID: string;
}

export interface GroupProductReorderItem {
	salesChannelCategoryGroupProductID: string;
	displayOrder: number;
}

export const useSalesChannelCategoryGroupProductMutations = () => {
	const [, create] = useSalesChannelCategoryGroupProductCreateMutation();
	const [, update] = useSalesChannelCategoryGroupProductUpdateMutation();
	const [, del] = useSalesChannelCategoryGroupProductDeleteMutation();
	const [, reorder] = useSalesChannelCategoryGroupProductReorderMutation();

	return {
		create: (input: GroupProductCreateInput) => create({ input }),
		update: (input: GroupProductUpdateInput) => update({ input }),
		remove: (id: string) => del({ id }),
		reorder: (input: GroupProductReorderItem[]) => reorder({ input }),
	};
};
